import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { formatLicensePlate } from '../../../utils/string';
import {selectCompanies} from "../../Companies/selectors";
import {ORBModal} from "../components/ORBModal";

const Container = styled.div`
  margin-bottom: 24px;
  width: 100%;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }
`;

const StockCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: white;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  gap: 5px;
`

const Subtitle = styled.h2`
  font-size: 18px;
  font-weight: normal;
  padding-left: 12px;
  text-align: left;
`
const Divider = styled.hr`
  height: 2px;
  border-top: 1px solid #0183D5;
  width: 100%;
  margin: -15px 0 -5px;
  padding: 0 24px;
`

const STATE =  {
    modal :false,
    selectedItem: null,
};


/* eslint-disable react/prefer-stateless-function */
class ORBStockItemComp extends BaseComponent {

  constructor(props) {
    super(props, { ...STATE });
  }

  reset(){
      this.setState({...STATE})
  }

  closeModal = () => {
    this.setState({ modal: false })
  }

  renderCard = () => {
    const { item } = this.props;
    return (
      <StockCard>
          <div>
            <strong>ID: </strong> {item.voertuigId}
          </div>
          <div>
            <strong>Kenteken: </strong> {item?.kenteken ?? ' -'}
          </div>
          <div>
            <strong>Brand/model:</strong>  {`${item.merk} ${item.model}`}
          </div>
          <div>
            <strong>Counter reading:</strong> {item.kilometerstand ?? 'N/A'}
          </div>
          <div>
            <strong>Type voorraad: </strong> {item.voorraadsoort ?? ' -'}
          </div>
        <div style={{ alignSelf: 'center'}}>
          <Button onClick={this.setStateFn({modal:true, selectedItem: {...item}})}>ORB-B2B Uitgaand </Button>
        </div>
      </StockCard>
    );
  };

  render(){

    const i = this.props.item;
    return <Container>
      { this.state.modal && <ORBModal item={this.state.selectedItem} onClose={this.closeModal} /> }
      { window.innerWidth <= 768 ? this.renderCard() :
        <HBox className="item-row" left vCenter flip={window.innerWidth <= 768}>
            <div>
                {i.voertuigId}
            </div>
            <div>
            {formatLicensePlate(i.kenteken)}
            </div>
            <div>
              {`${i.merk} ${i.model}`}
            </div>
            <div>{i.kilometerstand ? `${i.kilometerstand} km` : 'N/A'}</div>
            <div>
            {i.voorraadsoort}
            </div>
            <div>
                <Button onClick={this.setStateFn({modal:true, selectedItem: {...i}})}>ORB-B2B Uitgaand </Button>
            </div>
        </HBox>
      }
    </Container>

  }

}

ORBStockItemComp.propTypes = {
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  companies: selectCompanies(),
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  }
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ORBStockItem = compose(
  withRouter,
  withConnect
)(ORBStockItemComp);
